import script from "./PracticeTyping.vue?vue&type=script&setup=true&lang=js"
export * from "./PracticeTyping.vue?vue&type=script&setup=true&lang=js"

import "./PracticeTyping.vue?vue&type=style&index=0&id=3fe2e1aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fe2e1aa"]])

export default __exports__